"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadCanva;

var _loadScript = _interopRequireDefault(require("FileManagerCore/utils/loadScript"));

var CANVA_SCRIPT_URL = 'https://sdk.canva.com/v2/beta/api.js';

function loadCanva() {
  return (0, _loadScript.default)(CANVA_SCRIPT_URL);
}

module.exports = exports.default;